import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ORDER_DELIVERY, storageKey, isNewCond } from "@/lib/store";

const norm = (s = "") => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/tit[a]nio|[-\s]/g, "");
export const sameColor = (a, b) => !!a && !!b && (norm(a) === norm(b) || norm(a).includes(norm(b)) || norm(b).includes(norm(a)));

const base = "rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-300";
const activeCls = `${base} border-white bg-white text-black`;
const availCls = `${base} border-white/15 text-zinc-200 hover:border-white/50 hover:text-white`;
const missingCls = `${base} border-dashed border-white/15 text-zinc-400 hover:border-amber-300/60 hover:text-amber-200`;

const Choice = ({ target, active, onMissing, testid, children }) => {
  if (target) return <Link to={`/produto/${target.id}`} replace data-testid={testid} className={active ? activeCls : availCls}>{children}</Link>;
  return <button type="button" data-testid={testid} data-missing="true" onClick={onMissing} className={missingCls} title="Sob encomenda">{children}</button>;
};

export const orderLink = ({ model, storage, color }) => {
  const q = new URLSearchParams({ cat: "iphone", model, storage: storage || "", color: color || "", cond: "novo" });
  return `/?${q.toString()}#pedido`;
};

export const NewOptions = ({ product, sameModel, options }) => {
  const [pending, setPending] = useState(null);
  const novos = sameModel.filter((p) => isNewCond(p.condition));
  const sameS = (p, s) => storageKey(p.storage) === storageKey(s);
  const find = (fn) => novos.find(fn) || sameModel.find(fn);
  const storageTarget = (s) => find((p) => sameS(p, s) && sameColor(p.color, product.color)) || find((p) => sameS(p, s));
  const colorTarget = (c) => find((p) => sameS(p, product.storage) && sameColor(c, p.color));

  return (
    <>
      <div data-testid="new-storages">
        <p className="mono mb-2 text-[11px] uppercase tracking-[0.22em] text-zinc-400">Armazenamento</p>
        <div className="flex flex-wrap gap-2">
          {options.storages.map((s) => (
            <Choice key={s} target={storageTarget(s)} active={storageKey(s) === storageKey(product.storage)} testid={`new-storage-${s.toLowerCase()}`}
              onMissing={() => setPending({ storage: s, color: product.color })}>{s}</Choice>
          ))}
        </div>
      </div>
      <div data-testid="new-colors">
        <p className="mono mb-2 text-[11px] uppercase tracking-[0.22em] text-zinc-400">Cor</p>
        <div className="flex flex-wrap gap-2">
          {options.colors.map((c) => (
            <Choice key={c} target={colorTarget(c)} active={sameColor(c, product.color)} testid={`new-color-${norm(c)}`}
              onMissing={() => setPending({ storage: product.storage, color: c })}>{c}</Choice>
          ))}
        </div>
      </div>
      <p className="text-xs text-zinc-400">Opções com borda tracejada estão sob encomenda.</p>
      {pending && (
        <div data-testid="new-option-order-box" className="rounded-2xl border border-amber-300/30 bg-amber-300/10 p-4">
          <p className="font-semibold text-white">{product.model} {pending.storage} {pending.color} está sob encomenda.</p>
          <p className="mt-1 text-sm text-zinc-300">{ORDER_DELIVERY}</p>
          <Link data-testid="new-option-order-link" to={orderLink({ model: product.model, ...pending })}
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-black transition-transform active:scale-95">
            Fazer pedido <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      )}
    </>
  );
};
